<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-upload
          class="mlr-10px"
          :action="action"
          :show-file-list="false"
          :on-success="handleFileSuccess"
        >
          <el-button type="warning">点击上传</el-button>
        </el-upload>
        <el-button type="primary" @click="handleCreated">录入</el-button>
      </template>
    </com-search>
    <com-card>
      <com-table ref="table" :columns="columns" :api="api">
        <template #bandTime="row">
          {{ row.data.bandTime | timeFormate }}
        </template>
        <template #status="row">
          {{ statusMap[row.data.status] }}
        </template>
        <template #operation="row">
          <el-button v-if="row.data.status === 0" type="primary" size="mini" @click="handleBindUser(row.data)">绑定</el-button>
          <el-button v-if="row.data.status === 1" type="warning" size="mini" @click="handleUnbindUser(row.data)">解绑</el-button>
          <el-button v-if="row.data.status === 2" type="success" size="mini" @click="handleValid(row.data)">启用</el-button>
          <el-button v-if="row.data.status !== 2 " type="default" size="mini" @click="handleInvalid(row.data)">作废</el-button>
          <el-button v-if="row.data.status === 0" type="danger" size="mini" @click="handleDelete(row.data)">删除</el-button>
        </template>
      </com-table>
    </com-card>
    <add-card ref="addCardRef" @update="update"></add-card>
    <bind-user ref="bindUser" @update="update"></bind-user>
  </com-page>
</template>

<script>
import { list, unBandCard, setValid, setInvalid, delElectricCard } from '@/api/electric_card'
import bindUser from './components/bind-user-dialog'
import addCard from './components/add-card'
import request from '@/utils/service'

export default {
  components: { bindUser, addCard },
  data() {
    return {
      api: list,
      action: `${request.defaults.baseURL}/card/importCardExcel`,
      searchColumns: [
        {
          label: '电卡号',
          prop: 'cardNo',
          type: 'input'
        },
        {
          label: '用户手机号',
          prop: 'userCondition',
          type: 'input'
        },
        {
          label: '网点',
          prop: 'storeName',
          type: 'input'
        },
        {
          label: '状态',
          type: 'select',
          prop: 'status',
          option: [
            {
              label: '未绑定',
              value: 0
            },
            {
              label: '已绑定',
              value: 1
            },
            {
              label: '已作废',
              value: 2
            }
          ]
        }
      ],
      columns: [
        {
          label: '电卡号',
          prop: 'cardNo'
        },
        {
          label: '绑定用户ID',
          prop: 'userNumber'
        },
        {
          label: '绑定用户手机号',
          prop: 'userPhone'
        },
        {
          label: '网点',
          prop: 'storeName'
        },
        {
          label: '绑定时间',
          prop: 'bandTime',
          type: 'slot',
          slotName: 'bandTime'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation'
        }
      ],
      statusMap: {
        0: '未绑定',
        1: '已绑定',
        2: '已作废'
      }
    }
  },
  methods: {
    update() {
      this.$refs.table.getList()
    },
    handleBindUser(row) {
      this.$refs.bindUser.open(row)
    },
    handleCreated() {
      this.$refs.addCardRef.open()
    },
    handleSearch(val) {
      this.$refs.table.search(val)
    },
    // 解绑电卡
    handleUnbindUser(row) {
      this.$confirm('是否确认解绑？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          unBandCard(params).then(() => {
            this.$message.success('解绑成功')
            this.update()
          })
        })
        .catch(() => {})
    },
    // 启用电卡
    handleValid(row) {
      this.$confirm(`是否重新启用电卡${row.cardNo}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          setValid(params).then(() => {
            this.$message.success('操作成功')
            this.update()
          })
        })
        .catch(() => {})
    },
    // 使电卡作废
    handleInvalid(row) {
      this.$confirm(`是否将电卡${row.cardNo}作废？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          setInvalid(params).then(() => {
            this.$message.success('操作成功')
            this.update()
          })
        })
        .catch(() => {})
    },
    // 删除电卡
    handleDelete(row) {
      this.$confirm(`是否将电卡${row.cardNo}删除？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          delElectricCard(params).then(() => {
            this.$message.success('操作成功')
            this.update()
          })
        })
        .catch(() => {})
    },
    // 导入电卡
    handleFileSuccess(res) {
      if (res.status !== 200) return this.$message.error(res.desc)
      this.$message.success('导入成功')
      this.update()
    },
  }
}
</script>
<style lang="scss" scoped>
.search_wrapper {
  width: 100%;
  padding: 20px;
  background: white;
  margin-bottom: 15px;
  border-radius: 5px;
}
</style>
